import React, { Component, Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { withFormik, Field } from 'formik';
import * as yup from 'yup';
import MaskedInput from 'react-maskedinput';

import InputFeedback from '../InputFeedback';

const PaymentSchema = yup.object().shape({
  ccnumber: yup
    .string()
    .matches(/^\d{4} \d{4} \d{4} \d+(\d{1,4}|\ {1,})$/, {
      message: 'Invalid card number format',
      excludeEmptyString: true,
    })
    .required("Card number can't be empty"),
  exp_month: yup
    .string()
    .matches(/^(0?[1-9]|1[012])$/, {
      message: 'Expiration month is not valid',
      excludeEmptyString: true,
    })
    .required("exp_month can't be empty"),
  exp_year: yup
    .string()
    .matches(/^\d{2}$/, {
      message: 'Expiration year is not valid',
      excludeEmptyString: true,
    })
    .test({
      name: 'exp_year',
      test: value => parseInt(value, 10) >= new Date().getFullYear() - 2000,
      message: `Should be greater or equal to ${new Date().getFullYear() -
        2000}`,
    })
    .required("Expiration year can't be empty"),
  cvv2: yup
    .string()
    .matches(/^\d{3,}(\d+|)$/, {
      message: 'CVC is not valid',
      excludeEmptyString: true,
    })
    .required("CVC can't be empty"),
});

class UpdatePaymentDetails extends Component {
  renderButtons = () => {
    const {
      subscribed,
      toggle,
      createSubscription,
      payment_method_added,
      createSubscriptionSpinner,
    } = this.props;
    return (
      <Fragment>
        <span className="std-text blue m-l-15 pointer" onClick={toggle}>
          Change billing details
        </span>
        {!subscribed && payment_method_added && (
          <button
            className="btn btn-blue outline outline full-width m-t-30"
            onClick={createSubscription}
            disabled={createSubscriptionSpinner}>
            {createSubscriptionSpinner ? 'Loading' : 'Create a subscription'}
          </button>
        )}
      </Fragment>
    );
  };

  render() {
    const {
      isSubmitting,
      handleSubmit,
      isValid,
      touched,
      errors,
      toggle,
      isOpen,
      email,
      details,
      cost,
      plan,
    } = this.props;

    return (
      <Fragment>
        {this.renderButtons()}
        <Modal isOpen={isOpen} toggle={toggle} className={this.props.className}>
          <ModalHeader toggle={toggle}>
            <div className="h2-title">Payment details</div>
          </ModalHeader>
          <div className="separator-line" />
          <ModalBody>
            <div className="profile-modal">
              <div className="profile-modal__info profile__inner bg">
                <div className="b-row">
                  <div className="b-col-6 profile-modal__info-left">
                    <div className="std-text">Payment amount</div>
                    <div className="std-text bold">
                      ${cost}/{plan}
                    </div>
                  </div>
                  <div className="b-col-6 profile-modal__info-right">
                    <div className="std-text">Email</div>
                    <div className="std-text bold">{email}</div>
                  </div>
                </div>
              </div>
              <div className="profile-modal__descr">
                <div className="b-row position-relative form-group">
                  <div className="b-col-12">
                    <div className="form-group__top">
                      <label htmlFor="frmCCNum" className="form-group__label">
                        Card number
                      </label>
                    </div>
                    <Field
                      name="ccnumber"
                      render={({ field }) => (
                        <MaskedInput
                          type="text"
                          id="frmCCNum"
                          className="form-input input-border form-control"
                          mask="1111 1111 1111 1111"
                          placeholderChar=" "
                          placeholder="XXXX XXXX XXXX XXXX"
                          size="19"
                          autoComplete="cc-number"
                          {...field}
                        />
                      )}
                    />
                    <InputFeedback
                      error={touched.ccnumber && errors.ccnumber}
                    />
                  </div>
                </div>
                <div className="b-row">
                  <div className="b-col-4">
                    <div className="form-group">
                      <div className="form-group__top">
                        <label
                          htmlFor="cc-exp-month"
                          className="form-group__label">
                          Expiration month
                        </label>
                      </div>
                      <Field
                        name="exp_month"
                        render={({ field }) => (
                          <MaskedInput
                            id="cc-exp-month"
                            className="form-input input-border form-control"
                            mask="11"
                            placeholder="05"
                            placeholderChar=" "
                            size="2"
                            autoComplete="cc-exp-month"
                            {...field}
                          />
                        )}
                      />
                      <InputFeedback
                        error={touched.exp_month && errors.exp_month}
                      />
                    </div>
                  </div>
                  <div className="b-col-4">
                    <div className="form-group">
                      <div className="form-group__top">
                        <label
                          htmlFor="cc-exp-year"
                          className="form-group__label">
                          Expiration year
                        </label>
                      </div>
                      <Field
                        name="exp_year"
                        render={({ field }) => (
                          <MaskedInput
                            id="cc-exp-year"
                            className="form-input input-border form-control"
                            mask="11"
                            placeholder="25"
                            placeholderChar=" "
                            size="2"
                            autoComplete="cc-exp-year"
                            {...field}
                          />
                        )}
                      />
                      <InputFeedback
                        error={touched.exp_year && errors.exp_year}
                      />
                    </div>
                  </div>
                  <div className="b-col-4">
                    <div className="form-group">
                      <div className="form-group__top">
                        <label htmlFor="cvv2" className="form-group__label">
                          CVC
                        </label>
                      </div>
                      <Field
                        name="cvv2"
                        render={({ field }) => (
                          <input
                            type="number"
                            id="cvv2"
                            className="form-input input-border form-control"
                            placeholder="***"
                            size="4"
                            maxLength="4"
                            autoComplete="cc-csc"
                            {...field}
                          />
                        )}
                      />
                      <InputFeedback error={touched.cvv2 && errors.cvv2} />
                    </div>
                  </div>
                  <div className="b-col-6">
                    <div className="position-relative form-group">
                      <div className="form-group__top">
                        <label
                          htmlFor="first_name"
                          className="form-group__label">
                          First name
                        </label>
                      </div>
                      <Field
                        name="first_name"
                        render={({ field }) => (
                          <input
                            type="text"
                            id="first_name"
                            className="form-input input-border form-control"
                            placeholder=""
                            autoComplete="name"
                            {...field}
                          />
                        )}
                      />
                      <InputFeedback
                        error={touched.first_name && errors.first_name}
                      />
                    </div>
                  </div>
                  <div className="b-col-6">
                    <div className="position-relative form-group">
                      <div className="form-group__top">
                        <label
                          htmlFor="last_name"
                          className="form-group__label">
                          Last name
                        </label>
                      </div>
                      <Field
                        name="last_name"
                        render={({ field }) => (
                          <input
                            type="text"
                            id="last_name"
                            className="form-input input-border form-control"
                            placeholder=""
                            autoComplete="name"
                            {...field}
                          />
                        )}
                      />
                      <InputFeedback
                        error={touched.last_name && errors.last_name}
                      />
                    </div>
                  </div>
                  <div className="b-col-8">
                    <div className="position-relative form-group">
                      <div className="form-group__top">
                        <label htmlFor="country" className="form-group__label">
                          Billing country
                        </label>
                      </div>
                      <Field
                        name="country"
                        render={({ field }) => (
                          <input
                            type="text"
                            id="country"
                            className="form-input input-border form-control"
                            autoComplete="country"
                            {...field}
                          />
                        )}
                      />
                      <InputFeedback
                        error={touched.country && errors.country}
                      />
                    </div>
                  </div>
                  <div className="b-col-4">
                    <div className="position-relative form-group">
                      <div className="form-group__top">
                        <label htmlFor="zip" className="form-group__label">
                          ZIP code
                        </label>
                      </div>
                      <Field
                        name="zip"
                        render={({ field }) => (
                          <input
                            type="text"
                            id="zip"
                            className="form-input input-border form-control"
                            autoComplete="zipcode"
                            {...field}
                          />
                        )}
                      />
                      <InputFeedback error={touched.zip && errors.zip} />
                    </div>
                  </div>
                  <div className="b-col-12">
                    <div className="position-relative form-group">
                      <div className="form-group__top">
                        <label htmlFor="country" className="form-group__label">
                          Billing address
                        </label>
                      </div>
                      <Field
                        name="address"
                        render={({ field }) => (
                          <input
                            type="text"
                            id="address"
                            className="form-input input-border form-control"
                            autoComplete="address"
                            {...field}
                          />
                        )}
                      />
                      <InputFeedback
                        error={touched.address && errors.address}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="blue"
              className="m-r-15"
              onClick={handleSubmit}
              disabled={!isValid || isSubmitting}>
              {isSubmitting ? 'Loading' : 'Update card'}
            </Button>{' '}
            <Button color="blue" className="outline" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default withFormik({
  mapPropsToValues: () => ({
    ccnumber: '',
    exp_month: '',
    exp_year: '',
    cvv2: '',
    country: '',
    address: '',
    zip: '',
  }),
  isInitialValid: false,
  validationSchema: PaymentSchema,
  handleSubmit: async (
    values,
    { props, setSubmitting, setErrors, resetForm },
  ) => {
    await props.handleSubmit(values, setSubmitting, setErrors, resetForm);
  },
})(UpdatePaymentDetails);



// WEBPACK FOOTER //
// ./src/components/UpdatePaymentDetails/UpdatePaymentDetails.js